import { render, staticRenderFns } from "./ViewLot.vue?vue&type=template&id=631570a5"
import script from "./ViewLot.vue?vue&type=script&lang=js"
export * from "./ViewLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports